import React from 'react';

interface ExamContentGuardProps {
  children: React.ReactNode;
  /** When true, disables copy protection (e.g. when devTools=true for debugging) */
  disabled?: boolean;
  className?: string;
}

/**
 * Wraps exam content to discourage copying: disables text selection and right-click context menu.
 * Do not use on user input areas (textarea, recording UI, answer buttons).
 */
export const ExamContentGuard: React.FC<ExamContentGuardProps> = ({
  children,
  disabled = false,
  className,
}) => {
  if (disabled) {
    return <>{children}</>;
  }
  return (
    <div
      className={className}
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none',
      }}
      onContextMenu={(e) => e.preventDefault()}
    >
      {children}
    </div>
  );
};

export default ExamContentGuard;
